<template>
    <div class="addReview center" align-v="center">
        <b-container>
            <b-row class="my-3">
                <b-col>
                    <p class="h3">
                        <strong>New Toho Food Center</strong>
                    </p>
                </b-col>
                <b-col class="text-right">
                    <b-link>
                        Read our review guidelines
                    </b-link>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <Star
                        ref="star"
                        :fontScale=2
                        :readOnly=false
                    /> 
                </b-col>
            </b-row>
            <b-row class="my-3">
                <b-col>
                    <b-form-textarea
                        id="textarea"
                        v-model="text"
                        :placeholder="placeholder"
                        rows="10"
                        max-rows="10"
                    ></b-form-textarea>
                </b-col>
            </b-row>
            <b-row class="my-3">
                <b-col>
                    <p class="h5">
                        <strong>Attach Photos</strong>
                    </p>
                </b-col>
            </b-row>
            <b-row class="my-3">
                <b-col>
                    <b-form-file
                        v-model="file1"
                        :state="Boolean(file1)"
                        multiple
                        placeholder="Choose a photo or drop it here..."
                        drop-placeholder="Drop file here..."
                    ></b-form-file>
                </b-col>
            </b-row>
            <b-row class="my-3">
                <b-col>
                    <b-button variant="primary" class="mr-2" @click="postReview">
                        Post Review
                    </b-button>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<style scoped>
.addReview {
    padding-top: 5%;
    margin-right: 20%;
    margin-left: 20%;
}

</style>

<script>
import Star from '../components/place/Star'

export default {
    components: {
        Star
    },
    data() {
        return {
            text: "",
            file1: [],
            chosenStar: 0,
            placeholder: "This spot is serving meal kits, as well as offering delivery during COVID. I’m so glad! Of course nothing beats the in-person experience, but delivery is a great second option right now. The food was a little cold, but I understand this is a new operation for them..."
        }
    },
    methods: {
        postReview() {
            console.log('post review')
            var rating = {
                placeId: this.$route.params.id,
                text: this.text,
                star: this.$refs.star.clickedRating,
                files: this.file1
            }
            rating
            //console.log(this.file1)
            console.log('rating', rating)
            this.$store.dispatch('postReview', rating)
        }
    },
    
}
</script>